export default __webpack_public_path__ + "static/media/triangle.5d315be3.svg";